/**
 * 날짜기반 상대값
 * @param {string} date
 * @param {string} lang
 * @returns {string}
 */
export const relativeDateExp = (date: string, lang: string): string => {
	const rtf = new Intl.RelativeTimeFormat(lang, { numeric: 'auto' });
	const temp = new Date(date).getTime() - Date.now();
	// const temp2 = new Date('2023-10-31') - Date.now()
	// console.log('test:::', rtf.formatToParts(Math.ceil(temp2 / 24 / 60 / 60 / 1000), 'day'))
	const tempDate = new Date(date);
	const options = {
		hour: 'numeric',
		hour12: false,
		minute: 'numeric',
		weekday: 'short',
	} as const;

	const [weekday, time] = new Intl.DateTimeFormat('en-US', options).format(tempDate).split(' ');
	const date2 = rtf.formatToParts(Math.ceil(temp / 24 / 60 / 60 / 1000), 'day');

	const result = date2.map((item) => item.value).join(' ');
	return `${result}, ${time}`;
};

export const allDate = (input: string) => {
	const date = new Date(input);
	const options = {
		day: 'numeric',
		hour: 'numeric',
		hour12: false,
		minute: 'numeric',
		month: 'numeric',
		weekday: 'short',
		year: 'numeric',
	} as const;
	// 되는 기능인데 타입스크립트에 정의 안된 이슈

	const [weekday, mdy, time] = new Intl.DateTimeFormat('en-US', options).format(date).split(',');
	// weekday, 11/25/2023, 09:00
	const ymd = mdy.split('/').map((item) => item.trim());
	const year = ymd.pop();
	if (year) ymd.unshift(year);
	return { time, weekday, ymd };
};

// const a = {
//   a: '1',
//   b: '2',
//   c: '3',
// }

/**
 * 2024.06.28 / 00:00 */
export const YYYYMMDDHHmm = (date: Date) => {
	const formattedDate = date.toLocaleDateString('en-GB', {
		day: '2-digit',
		month: '2-digit',
		year: 'numeric',
	});

	const [day, month, year] = formattedDate.split('/');
	const formattedDatePart = `${year}.${month}.${day}`;

	const formattedTime = date.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
	return formattedDatePart + ' / ' + formattedTime;
};

/**
 * 00:00 */
export const HHmm = (date: Date) => {
	const formattedTime = date.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
	return formattedTime;
};

/**
 * 00:00 */
export const HHmmUTCZero = (date: Date) => {
	// UTC 시간으로 변환
	const utcHours = date.getUTCHours();
	const utcMinutes = date.getUTCMinutes();

	// 시간과 분을 2자리 문자열로 포맷팅
	const formattedTime = `${String(utcHours).padStart(2, '0')}:${String(utcMinutes).padStart(2, '0')}`;
	return formattedTime;
};

export const YYYYMMDD = (date: Date) => {
	const formattedDate = date.toLocaleDateString('en-GB', {
		day: '2-digit',
		month: '2-digit',
		year: 'numeric',
	});

	const [day, month, year] = formattedDate.split('/');
	const formattedDatePart = `${year}.${month}.${day}`;

	return formattedDatePart;
};

/** 안전하게 string을 Date로 데이터 변환..? */
export function parseISODate(dateStr: string) {
	const date = new Date(dateStr);
	if (isNaN(date.getTime())) {
		console.log(date, dateStr);
		throw new Error('Invalid date');
	}
	return date;
}

export function formatDuration(milliseconds: number) {
	const abs = Math.abs(milliseconds);
	const seconds = Math.floor((abs / 1000) % 60);
	const minutes = Math.floor((abs / (1000 * 60)) % 60);
	const hours = Math.floor(abs / (1000 * 60 * 60));
	const formatted = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
	return [milliseconds >= 0 ? '' : '-', formatted].join('');
}

export const relativeTime = (time: string) => {
	const now = new Date().getTime();
	const parse = parseISODate(time).getTime();
	return formatDuration(parse - now);
};
